import useFetchData from '../../../../../hooks/fetchHook';
import { reportsKeys } from '../controllers/variables';

export const useGetReportsMonths = ({ year }) => {
  const [{ data, isLoading = true, isError, error }] = useFetchData(
    'reports/months',
    {
      params: formatParams(year),
      formatter,
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
  };
};

const formatter = data => {
  const formattedData = data.map(month => ({
    ...month,
    [reportsKeys.name]: `${
      months[new Date(month.startDate).getMonth()]
    } ${new Date(month.startDate).getFullYear()}`,
    year: new Date(month.startDate).getFullYear(),
  }));
  return formattedData;
};

const formatParams = year => year;

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
